import React, { useEffect, useState, useRef } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Stack,
  Table,
  Form,
  Modal,
  FormGroup,
  FormLabel,
} from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Select from "react-select";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";
import PubSub from "pubsub-js"; //Added by shahir hussain 19-12-2025

import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";
import DateRangePicker from "rsuite/DateRangePicker";
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/DateRangePicker/styles/index.css";
import ".././../assets/css/ListComponentsTable.css";
import {
  formatDate,
  getUserDetails,
  formatDateForView,
} from "../../utils/helper";
import InfoPill from "../InfoPill";
import { CSVUpload } from "../../utils/CSVUpload";
import * as constants from "../../constants/CONSTANT";
import { OFFER_STATUS_VALUES } from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import moment from "moment"; //Added by shahir hussain 19-12-2025
import UserMultiSelect from "../common/UserMultiSelect";
import { parseDashboardFilterParams } from "../../utils/dashboardFilterParams";

const OfferList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardFilters = parseDashboardFilterParams(location.search);
  const [body, setBody] = useState();
  const [filterData, setFilterData] = useState(() => ({
    offer_status: dashboardFilters.hasOfferStatus ? dashboardFilters.offerStatus : "Offer Pending",
    ...(dashboardFilters.ownerIds ? { owner_ids: dashboardFilters.ownerIds } : {}),
  }));
  const [dateRange, setDateRange] = React.useState(dashboardFilters.dateRange || []);

  useEffect(() => {
    if (dashboardFilters.from && dashboardFilters.to) {
      setDateRange([
        new Date(dashboardFilters.from),
        new Date(dashboardFilters.to),
      ]);
    }
    setFilterData((prev) => ({
      ...prev,
      offer_status: dashboardFilters.hasOfferStatus ? dashboardFilters.offerStatus : prev.offer_status,
      ...(dashboardFilters.ownerIds ? { owner_ids: dashboardFilters.ownerIds } : {}),
    }));
  }, [location.search]);
  const [leads, setLeads] = useState([]);
  const [statusArray, setStatusArray] = useState(constants.OFFER_STATUS_VALUES);
  const [assignUsers, setAssignUsers] = useState([]);
  const [accounts, setAccounts] = useState([]); //Added by shahir hussain AMC Case Ticket 1005 12-12-2025
  //Add this all states by shahir hussain for changer owners 19-12-2025
  const [changeOwnerModal, setChangeOwnerModal] = useState(false); //Added by shahir hussian for owner change
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [ownerLeads, setOwnerLeads] = useState([]);
  const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
  const [fromUser, setFromUser] = useState({});
  const [toUser, setToUser] = useState({});
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
  const [leadCities, setLeadCities] = useState([]);
  const [selectedToUsers, setSelectedToUsers] = useState([]);

  //Ended by shahir hussain

  useEffect(() => {
    const filter = { ...filterData };
    delete filter.owner_name;
    delete filter.product_name;
    delete filter.lead_name;

    Object.keys(filter).forEach(key => {
      if (filter[key] === "") {
        delete filter[key];
      }
    });

    filter.owner_ids = filter?.owner_ids
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    filter.account_id = filter?.accounts
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    delete filter.accounts;
    if (Array.isArray(dateRange) && dateRange.length > 0)
      filter.date_range = {
        filed: "createddate",
        createddate: {
          from: formatDate(dateRange?.at(0) || null),
          to: formatDate(dateRange?.at(1) || null),
        },
      };
    fetchOffers(filter);
  }, [dateRange, filterData]);

  async function init() {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedUsers = await fuziElevatorsApi.fetchUsers();
      resultedUsers &&
        Array.isArray(resultedUsers) &&
        setAssignUsers(
          resultedUsers.map((user) => ({
            value: user.id,
            label: user.username,
          })),
        );
    }
    //Added by shahir hussain AMC Case Ticket 1005 12-12-2025
    const resultedAccounts = await fuziElevatorsApi.fetchAccounts();
    resultedAccounts &&
      Array.isArray(resultedAccounts) &&
      setAccounts(resultedAccounts);
  }

  useEffect(() => {
    init();
  }, []);

  async function fetchOffers(filters) {
    const result = await fuziElevatorsApi.fetchOffers(filters);
    if (result) {
      setBody(result);
    } else {
      setBody([]);
    }
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_LEAD].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      fuziElevatorsApi.fetchLeads().then((result) => {
        setLeads(result);
      });
    }
  }

  // Create table headers consisting of 4 columns.
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Job Number",
        prop: "offer_name_label",
        isFilterable: true,
        cell: (row) => (
          <Link to={`${ROUTES.OFFER.LIST}/${row.id}`} state={row}>
            {row.offer_name_label}
          </Link>
        ),
        isSortable: true,
      },
      // {
      //     title: "Offer Name", prop: "offer_name", isFilterable: true, isSortable: true,
      // },
      //formatDateForView added by shahir hussain 27-08-2025
      {
        title: "Offer Date",
        prop: "offer_date",
        isFilterable: true,
        cell: (row) =>
          row?.offer_date ? formatDateForView(row.offer_date) : "",
        isSortable: true,
      },
      // { title: "Status", prop: "offer_status", isFilterable: true, isSortable: true, },
      { title: "Site Address", prop: "site_address", isFilterable: true },
      { title: "City", prop: "city", isFilterable: true },
      { title: "Phone", prop: "phone", isFilterable: true },
      // {//commented by shahir hussain 12-12-2025
      //     title: "Make",
      //     prop: "accounts",
      //     cell: (row) => (

      //         row.accounts?.map((item) =>
      //             item?.value && <>
      //                 <Link to={`${ROUTES.ACCOUNT.LIST}/${item.value}`} >
      //                     {item.label}
      //                 </Link>
      //                 <br />
      //             </>

      //         )),
      //     isFilterable: true,
      // },
      {
        // Added by shahir hussain AMC Case Ticket 1005 12-12-2025
        title: "Make",
        prop: "accounts",
        cell: (row) => {
          if (!row.account_id || !Array.isArray(row.account_id)) return null;

          const matchedAccounts = accounts.filter((acc) =>
            row.account_id.includes(acc.id),
          );

          return (
            <>
              {matchedAccounts.map((acc, index) => (
                <span key={acc.id}>
                  <Link to={`${ROUTES.ACCOUNT.LIST}/${acc.id}`}>
                    {acc.name}
                  </Link>
                  {index < matchedAccounts.length - 1 && ", "}
                </span>
              ))}
            </>
          );
        },
        isFilterable: true,
      },
      {
        title: "Enquiry No",
        prop: "enquiry_no",
        isFilterable: true,
        cell: (row) => (
          <Link
            to={`${ROUTES.LEAD.LIST}/${row.lead_id}`}
            state={{ id: row.lead_id }}
          >
            {row.enquiry_no}
          </Link>
        ),
        isSortable: true,
      },
      { title: "Lead Type", prop: "leadtype", isFilterable: true },
      {
        title: "Product",
        prop: "product_name",
        cell: (row) => (
          <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`}>
            {row.product_name}
          </Link>
        ),
        isFilterable: true,
      },
      { title: "Offer Rate", prop: "highest_model_rate", isFilterable: true },
      // { title: "Units", prop: "number_of_units", isFilterable: true },
      {
        title: "Offer Status",
        prop: "offer_status",
        isFilterable: true,
        isSortable: true,
        alignment: { horizontal: "center" },
        cell: (row) => (
          <span
            className="badge rounded-pill w-100"
            style={getStatusClass(row.offer_status)}
          >
            {row.offer_status}
          </span>
        ),
      },
      //commented by shahir hussain 21-08-2025
      // {
      //     title: 'Assign User',
      //     prop: 'owner_name',
      //     isFilterable: true,
      //     cell: (row) =>
      //         <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`} state={row}>
      //             {row.owner_name}
      //         </Link>,
      // },
      {
        title: "Remark",
        prop: "offer_remark",
        isFilterable: true,
        isSortable: true,
      },
    );
  } else {
    //for mobile device
    header.push({
      title: "Info",
      prop: "offer_name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.OFFER.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.offer_name}
          </Link>

          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.email}
          </span>
        </div>
      ),
    });
  }
  const labels = {
    beforeSelect: " ",
  };

  const createOffer = () => {
    navigate(ROUTES.OFFER.CREATE);
  };

  const handleChange = (e) => {
    //For Filteration Work.
    setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  //For Searching Filteration.
  const handleSearch = async (e) => {
    // console.log("Leaad", filterData);
    const result =
      await fuziElevatorsApi.fetchAllFilterRecordsOffer(filterData);
    // console.log("result", result);
    setBody([...result]);
  };

  //For Searching Filteration Clear.
  const handleClear = () => {
    setFilterData({});
    fetchOffers();
  };

  const getStatusClass = (status) => {
    const statusObj = OFFER_STATUS_VALUES.find(
      (value) => value.label === status,
    );
    return statusObj ? statusObj.css : {};
  };

  const customFilter = (rows, filters) => {
    return rows.filter((row) => {
      return Object.keys(filters).every((column) => {
        const filterValue = filters[column]?.toLowerCase() || "";
        if (!filterValue) return true; // filter empty hai to row include karo

        const rowValue = row[column]?.toString().toLowerCase() || "";
        return rowValue.includes(filterValue); // substring + case-insensitive
      });
    });
  };

  //Added by shahir hussain for change owner 19-12-2025
  useEffect(() => {
    (async () => {
      try {
        const fetchUsers = await fuziElevatorsApi.fetchUsersForListPage();
        if (Array.isArray(fetchUsers)) {
          setUsers(
            fetchUsers?.map(({ id, username, userrole }) => ({
              value: id,
              label: `${username} - ${userrole}`,
            })),
          );
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error("Failed to load users/contacts:", error);
        setUsers([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (fromUser && fromUser?.value) {
        setSpinnerForChangeOwner(true);
        const leads = await fuziElevatorsApi.getOfferByStaffId(fromUser?.value);
        if (leads.success) {
          setOwnerLeads(leads?.data);
          setOwnerLeadsHeader([
            {
              title: (
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  label="Select All"
                  name="all_offers"
                  onChange={handelCheckBox}
                />
              ),
              prop: "id",
              isFilterable: true,
              cell: (row) => (
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`${row.id}`}
                  name="offers"
                />
              ),
            },
            {
              title: "JOB NUMBER",
              prop: "offer_name_label",
              isFilterable: true,
              cell: (row) => (
                <Link to={"/offers/" + row.id} state={row}>
                  {row.offer_name_label}
                </Link>
              ),
            },
            {
              title: "Created Date",
              prop: "createddate",
              isSortable: true,
              isFilterable: true,
              cell: (row) => (
                <span>{moment(row.createddate).format("DD-MM-yyyy")}</span>
              ),
            },
            {
              title: "Assigned",
              prop: "ownername",
              isFilterable: true,
              isSortable: true,
              cell: (row) => {
                const titleAbbreviations = {
                  "Sales Admin": "S. S.",
                  "Installation Admin": "I. A.",
                  Accounts: "ACCOUNTS",
                  "Accounts Admin": "A. A.",
                  "Installation Engineer": "I. E.",
                  "Installation Supervisor": "I. S.",
                  "Business Development Executive": "B. D. E.",
                  "Customer Relationship Executive": "C. R. E.",
                  Office: "OFFICE",
                  "Office Coordinator": "O. C.",
                  "Office Executive": "O. E.",
                  "Service Admin": "S. R.",
                  SUPER_ADMIN: "SUPER_ADMIN", // If no abbreviation is needed
                };

                // Split ownername and ownerid arrays
                const ownerNames = row.ownername
                  ? row.ownername.split(", ")
                  : [];
                const ownerIds = row.ownerid ? row.ownerid : [];

                // Function to shorten titles
                const shortenTitle = (name) => {
                  const [fullName, title] = name.split(" - ");
                  const shortTitle = titleAbbreviations[title.trim()] || title; // Use abbreviation if available
                  return `${fullName} - ${shortTitle}`;
                };

                // Ensure ownerNames and ownerIds arrays are of the same length
                const links = ownerNames.map((name, index) => (
                  <Link
                    key={index} // Use index as key if ownerIds[index] is not reliable
                    to={`/users/${ownerIds[index]}`}
                    state={row}
                    className="align-items-center justify-content-start"
                  >
                    {shortenTitle(name)}
                    <br />
                  </Link>
                ));
                return <span>{links}</span>;
              },
            },
          ]);
        } else {
          setOwnerLeads([]);
          setOwnerLeadsHeader([]);
        }
        setSpinnerForChangeOwner(false);
      } else {
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
      }
    })();
  }, [fromUser]);

  const handelChangeOwnerModalClose = () => {
    setChangeOwnerModal(false);
    setRefreshRecords(!refreshRecords);
    setOwnerLeads([]);
    setOwnerLeadsHeader([]);
    setFromUser({});
    setToUser({});
    setSelectedToUsers([]);
  };

  const ChangeOwner = (e) => {
    e.preventDefault();
    let leads = [
      ...tableRef?.current?.querySelectorAll(`input[name='offers']`),
    ];
    leads = leads?.filter((elm) => elm.checked);
    leads = leads?.map((elm) => elm.id);

    const toUsers = selectedToUsers.map((u) => u.value);
    console.log("toUsers == ", toUsers);

    (async () => {
      // const result = await fuziElevatorsApi.ChangeOfferOwner({ fromUser: fromUser.value, toUser: toUser.value, leads });
      const result = await fuziElevatorsApi.ChangeOfferOwner({
        fromUser: fromUser.value,
        toUser: toUsers,
        leads,
      });
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Transfer Owner",
          message: "Owner Transfer successfully",
        });
        setSelectedToUsers([]);
        handelChangeOwnerModalClose();
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Transfer Owner Error",
          message: "Some error occurred",
        });
      }
    })();
  };

  const handelFromUserSelect = (e) => {
    if (e) {
      setFromUser(e);
    } else {
      setFromUser(e);
    }
  };
  const handelToUserSelect = (e) => {
    setToUser(e);
  };
  const handelCheckBox = (e) => {
    [...tableRef.current.querySelectorAll(`input[name='offers']`)].forEach(
      (elm) => {
        elm.checked = e.target.checked;
      },
    );
  };
  return (
    <Container fluid>
      <DatatableWrapper
        body={body && Array.isArray(body) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
        sortProps={{ initialState: { prop: "offer_date", order: "desc" } }}
        filterFunction={customFilter}
      >
        <Row className="">
          {/* <p style={{ fontSize: "22px", display: "flex", justifyContent: "center", fontWeight: "bold" }}>Search Filter</p> */}
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label className="form-view-label" htmlFor="formBasicState">
                Enquiry (Lead)
              </Form.Label>

              <Select
                placeholder="Select your Lead"
                classNamePrefix="react-select"
                className="z-3"
                options={leads?.map((lead) => ({
                  value: lead?.id,
                  label: `${lead?.enquiry_no} - ${lead?.lead_name}`,
                }))}
                onChange={(e) => {
                  handleChange({
                    target: { name: "lead_id", value: e.value },
                  });
                  handleChange({
                    target: { name: "lead_name", value: e.label },
                  });
                }}
                value={
                  filterData?.lead_id
                    ? {
                      value: filterData?.lead_id,
                      label: filterData?.lead_name,
                    }
                    : ""
                }
              ></Select>
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={3}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label>Offer Status</Form.Label>
              <Form.Select
                name="offer_status"
                value={filterData?.offer_status || ""}
                onChange={handleChange}
              >
                <option value="">--Select-Status--</option>
                {statusArray.map((item, index) => (
                  <option value={item.label} key={index}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicLeadManagerId"
              >
                Assigned User
              </Form.Label>
              <Select
                className="z-3"
                classNamePrefix="react-select"
                // isClearable
                isMulti
                name="owner_ids"
                onChange={(e) => {
                  handleChange({
                    target: { name: "owner_ids", value: e },
                  });
                }}
                value={filterData?.owner_ids?.filter((item) => item.value)}
                options={assignUsers}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="align-items-end">
          <Col>
            <Filter
              classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }}
            />
          </Col>
          <Col md={1}>
            <PaginationOptions labels={labels} />
          </Col>

          <Col>
            <DateRangePicker
              value={dateRange}
              onChange={(e) => {
                setDateRange(e);
              }}
              // format="dd/mm/yyyy"
              character=" – "
            />
          </Col>
          <Col className="py-1">
            <BrowserView>
              <div className="d-flex py-1 px-2 ">
                <InfoPill
                  left="Total"
                  right={body?.length}
                  rightClasses="bg-custom text-white border-white fw-bold"
                  leftClasses="bg-white text-danger fw-bold "
                />
              </div>
            </BrowserView>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              {userInfo?.userrole === "SUPER_ADMIN" && (
                <Button
                  onClick={() => setChangeOwnerModal(true)}
                  className="btn-sm"
                >
                  Transfer Owner
                </Button>
              )}
              {/* <CSVUpload userInfo={getUserDetails()} init={init} parent={"offer"} /> */}
              {/* <Button variant="success" onClick={handleSearch}><i class="fas fa-search"></i></Button> */}
              <Button variant="secondary" onClick={handleClear}>
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </Button>
              {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_OFFER].some(
                (permission) => {
                  return userInfo?.permissions
                    ?.map((p) => p.name)
                    .includes(permission);
                },
              ) && (
                  <Button
                    size="sm"
                    className="btn-create"
                    onClick={() => createOffer(true)}
                  >
                    New Offer
                  </Button>
                )}
            </Stack>
          </Col>
        </Row>

        {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {
                        (body && Array.isArray(body)) ?
                            <TableBody />
                            :
                            <tbody className="">
                                <tr>
                                    <td colSpan={100} align="center">
                                        <div>
                                            <Spinner />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    }
                </Table> */}
        <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader
              classes={{ th: "bg-custom text-white sticky-header" }}
            />
            {body && Array.isArray(body) ? (
              <TableBody />
            ) : (
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
        <Pagination
          classes={{
            buttonGroup: "btn-custom",
            button: "bg-custom border-white",
          }}
        />
      </DatatableWrapper>
      {changeOwnerModal && (
        <Modal
          show={changeOwnerModal}
          onHide={handelChangeOwnerModalClose}
          size={"xl"}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Transfer Owner
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={ChangeOwner}>
            <Modal.Body>
              <Row className="gap-3">
                <Col lg={12}>
                  <Row className="">
                    <Col lg={6}>
                      <FormGroup>
                        <FormLabel>From</FormLabel>
                        <Select
                          isClearable
                          options={users}
                          onChange={handelFromUserSelect}
                          name="fromUser"
                          required
                        ></Select>
                      </FormGroup>
                    </Col>
                    <Col lg={6}>
                      <FormGroup>
                        {/* <FormLabel>To</FormLabel> */}
                        {/* <Select
                                                isClearable
                                                options={users}
                                                onChange={handelToUserSelect}
                                                name="toUser"
                                                required
                                            >
                                            </Select> */}
                        <UserMultiSelect
                          options={users}
                          value={selectedToUsers}
                          onChange={setSelectedToUsers}
                          label="To"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12}></Col>
              </Row>
              {/* New Change : Enhanced the UI and adder loader */}
              {fromUser && Object.keys(fromUser)?.length > 0 && (
                <Container style={{ height: "50vh", overflowY: "auto" }}>
                  {!spinnerForChangeOwner ? (
                    <DatatableWrapper
                      body={ownerLeads}
                      headers={ownerLeadsHeader}
                    >
                      <Table striped className="data-table" ref={tableRef}>
                        <TableHeader />
                        <TableBody />
                      </Table>
                    </DatatableWrapper>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center mt-5">
                      <Spinner
                        animation="border"
                        variant="secondary"
                        size="lg"
                      />
                    </div>
                  )}
                </Container>
              )}
            </Modal.Body>
            <Modal.Footer>
              <div className="submit">
                <Button variant="success" type="submit">
                  Change
                </Button>
              </div>
              <Button onClick={handelChangeOwnerModalClose} variant="light">
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </Container>
  );
};

export default OfferList;
